@import '@hevoio/hevo-ui-toolkit/styles/variables';

.upgradeToLiveChatBox {
  display: flex;
  flex-direction: column;
  padding: $spacer * 1.5;
}

.title {
  font-size: $font-size-subheader;
  flex-shrink: 0;
}

.supportRequestText {
  line-height: $spacer * 1.125;
}
